import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import styles from './orders.module.scss';

const RenderScreens = ({
  item,
  screenId,
  onClickMenu,
  isContinuousScroll
}) => {
  const headerRef = useRef(null);
  useEffect(() => {
    if ((headerRef?.current && Number(headerRef?.current?.id) === screenId)) {
      headerRef.current.classList = 'card w-100 col-12 text-center px-0 mb-2 background-secondary od-container-card-background od-text-primary text-primary';
    }
  }, []);

  const handleClick = (id) => {
    const headers = [...document.querySelectorAll('[data-header]')];
    const sections = [...document.querySelectorAll('[data-section]')];
    const section = sections.find((d) => d.id === id);
    if (section && isContinuousScroll) {
      section.scrollIntoView();
    }
    if (!isContinuousScroll) {
      window.sessionStorage.setItem('screenId', id);
      onClickMenu(id);
    }
    headers.forEach((header) => {
      const Header = header;
      if (header.id === id) {
        Header.classList = 'card w-100 col-12 text-center px-0 mb-2 background-secondary od-container-card-background od-text-primary text-primary';
      } else {
        Header.classList = 'card w-100 col-12 text-center px-0 mb-2 od-text-secondary text-secondary';
      }
    });
  };

  return (
    <div
      onClick={() => handleClick(`${item.id}`)}
      data-header={item.id}
      ref={headerRef}
      id={item.id}
      role="presentation"
    >
      <img
        id={item.id}
        src={item.imageUrl}
        alt=""
        className={cn('img-fluid mx-auto d-block', styles.screenImgHeight)}
      />
      <div id={item.id} className="text-center py-1">{item.name}</div>
    </div>
  );
};

const Menus = (props) => {
  const menusRef = useRef(null);
  const {
    allScreensList,
    onClickMenu,
    isContinuousScroll
  } = props;
  let screenId = Number(window.sessionStorage.getItem('screenId'));
  useEffect(() => {
    if (allScreensList) {
      if (!screenId) {
        screenId = Number(allScreensList?.[0]?.id);
      } else {
        onClickMenu(screenId);
      }
      window.sessionStorage.setItem('screenId', screenId);
    }
  }, [allScreensList]);

  return (
    <div ref={menusRef} className="col-12 col-md-12 px-1 py-1 h-100 od-text-primary text-primary overflowY overflowXHidden">
      {allScreensList && allScreensList.length > 0 && allScreensList.map((item) => {
        return (
          <RenderScreens
            item={item}
            screenId={screenId}
            onClickMenu={onClickMenu}
            isContinuousScroll={isContinuousScroll}
          />
        );
      })}
    </div>
  );
};

export default Menus;
